// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState, useContext, useCallback } from 'react';

// Material UI ( mui )  components
import { Box } from '@mui/material';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import PrefecturesList from '@components/MansionNavigation/PrefecturesList';
import PrefecturesListSp from '@components/MansionNavigation/SP/PrefecturesList';
import PrefecturesData from '@/types/components/MansionNavigation/PrefecturesData';
import RegionsData from '@/types/components/MansionNavigation/RegionsData';

interface PrefecturesListContentProps {
  prefecturesData: PrefecturesData;
  modePrefSelect: string;
  regionData: RegionsData;
}

// TODO: 型定義を修正 (元々指定してあった string | false だとエラーになる)
type IsExpanded = any;
const isExpandedInitial: IsExpanded = false;

export default function PrefecturesListContent({
  prefecturesData,
  modePrefSelect,
  regionData,
}: PrefecturesListContentProps): React.JSX.Element {
  const [expanded, setExpanded] = useState(isExpandedInitial);

  const isModePrefectures = modePrefSelect === 'prefectures';
  const postfixLinkText = isModePrefectures ? '/cities/' : '/lines/';
  const { pathRoot, isMobile } = useContext(AppConfigContext);

  const pathImageBgMap: string = `${pathRoot}/assets/images/common/bg_map.svg`;
  const pathImageBgTrain: string = `${pathRoot}/assets/images/common/bg_train.svg`;

  const accordionChange = useCallback(
    (panel: string) =>
      (_event: React.SyntheticEvent, isExpanded: IsExpanded): void => {
        setExpanded(isExpanded ? panel : false);
      },
    [],
  );

  return (
    <Box className="lg:mb-1">
      {isMobile ? (
        <PrefecturesListSp
          prefecturesData={prefecturesData}
          expanded={expanded}
          postfixLinkText={postfixLinkText}
          accordionChange={accordionChange}
        />
      ) : (
        <Box className="flex items-center">
          <PrefecturesList prefecturesData={prefecturesData} postfixLinkText={postfixLinkText} />
          <img src={isModePrefectures ? pathImageBgMap : pathImageBgTrain} alt="map" className="w-[25%] h-[25%]" />
        </Box>
      )}
    </Box>
  );
}
